import { AuthService } from '../auth.service';
import { AppConstants } from '../shared/app.constants';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
var StoreService = /** @class */ (function () {
    function StoreService(auth, appConstants, http) {
        this.auth = auth;
        this.appConstants = appConstants;
        this.http = http;
    }
    StoreService.prototype.getAllStores = function () {
        var url = environment.apiBase + 'all_stores';
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    StoreService.prototype.getStore = function (id) {
        var url = environment.apiBase + 'stores/' + id;
        var headers = this.auth.getAuthorizationHeaders();
        return this.http.get(url, { headers: headers }).map(function (res) { return res; }).catch(this.appConstants.errorHandler);
    };
    StoreService.prototype.registerStore = function (body) {
        var url = environment.apiBase + 'stores';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    StoreService.prototype.updateStore = function (body) {
        var url = environment.apiBase + 'stores/' + body.id;
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.put(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return StoreService;
}());
export { StoreService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/stores/store.service.ts.pre-build-optimizer.js